import { I } from '@angular/cdk/keycodes';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogServiceService } from '../dialog-service.service';
import { AmaService } from '../ama.service';
import { identifierModuleUrl } from '@angular/compiler';
@Component({
  selector: 'app-ask-crownit',
  templateUrl: './ask-crownit.component.html',
  styleUrls: ['./ask-crownit.component.css']
})
export class AskCrownitComponent implements OnInit, OnDestroy {
  public gender =  ['Male'];
  public age_arr = ['18-24'];
  public Question_type = 'Single Select';
  public Question: string;
  public city_arr =  ['Delhi NCR', 'Mumbai'];
  public SEC = ['SEC A,SEC B'];
  public Arr = [];

  
  public isNoOptionAdded:boolean = false;



  postData = {
    "question": [
      {
        "Q": "What is your ques",
        "T": "Single Select",
        "C": [
          "opt1",
          "opt2"
        ]
      }
    ],
    "audience": {
      "age": [
        "18-24"
      ],
      "gender": [
        "Male"
      ],
      "city": [
        "Delhi NCR",
        "Mumbai"
      ],
      "SEC": [
        "SEC A",
        "SEC B"
      ]
    },
    isFromEagleeye: true,
  }

  option_index = 1;

  constructor(public amaService: AmaService, private Dialog: DialogServiceService, private router: Router) { }

  ngOnInit(): void {
    // this.amaService.fetchSampleData();
  }
  
  ngOnDestroy(){
    /*
    this.amaService.newQuestion.question[0].Q = "";
    this.amaService.aduienceGender = {};
    this.amaService.audienceCity = {};
    this.amaService.audienceAge = {};
    this.amaService.audienceSec = {};
    this.amaService.audience = {};
    this.amaService.choices = {};
    this.amaService.qTypes = {};
    */
  }

  PopUp = () => {
    this.Dialog.OpenSampleDialoge();
  }
  SelChange(s: any) {
    if (s.value === 1 || s.value === 0) {
      this.amaService.sampleQuestion.qProperties[0].options['Single Select'] = 0;
      this.amaService.sampleQuestion.qProperties[0].options['Multiple Select'] = 0;
      this.amaService.sampleQuestion.qProperties[0].options[s.key] = 1;
      this.amaService.qTypes['Single Select'] = 0;
      this.amaService.qTypes['Multiple Select'] = 0;
      this.amaService.qTypes[s.key] = 1
      this.Question_type = s.key;
    }
  }
  IncreaseIndex = (val:number) => {
    console.log(val);
    this.option_index++;
  }
  ArrayMakers = () => {
    var arr = [];
    for (let i = 0; i < this.option_index; i++) {
      arr.push(i);
    }
    return arr;
  }
  GenderChange = (val: any, s: string) => {
    this.amaService.sampleDataFromApi['data'].audience[0].options['Both'] = 0;
    this.amaService.sampleDataFromApi['data'].audience[0].options['Male'] = 0;
    this.amaService.sampleDataFromApi['data'].audience[0].options['Female'] = 0;
    this.amaService.sampleDataFromApi['data'].audience[0].options[val.key] = 1;
    var d1 = this.gender.findIndex(va => va === val.key);
    if (d1 === -1) {
      this.gender.push(val.key);
    }
    else {
      this.gender.splice(d1, 1);
    }

  }
  CityChange = (val: any, s: string) => {
    if (val.value === 0 || val.value === 1) {
      var d = this.amaService.sampleDataFromApi['data'].audience[1].options[val.key];
      var z = d == 0 ? 1 : 0;

      let city = Object.keys(this.amaService.sampleDataFromApi['data'].audience[1].options).filter(item => { return this.amaService.sampleDataFromApi['data'].audience[1].options[item] == 1 })
    if (city.length && city.length == 4) {
      if (z == 0) {
        this.amaService.sampleDataFromApi['data'].audience[1].options[val.key] = z;
        var d1 = this.city_arr.findIndex(va => va === val.key);
        this.city_arr.splice(d1, 1);
      }else{
        return
      }
    }else{
      if (z == 0) {
        this.amaService.sampleDataFromApi['data'].audience[1].options[val.key] = z;
        var d1 = this.city_arr.findIndex(va => va === val.key);
        this.city_arr.splice(d1, 1);
      } else if (z == 1) {
        this.amaService.sampleDataFromApi['data'].audience[1].options[val.key] = z;
        // var d1 = this.city_arr.findIndex(va => va === val.key);
        this.city_arr.push(val.key);
      }
    }


      // this.amaService.sampleDataFromApi['data'].audience[1].options[val.key] = z; 
      // var d1 = this.city_arr.findIndex(va => va === val.key);
      // if (d1 === -1) {
      //   this.city_arr.push(val.key);
      // }
      // else {
      //   this.city_arr.splice(d1, 1);
      // }

    }
  }
  AgeChange = (val: any, s: string) => {
    if (val.value === 0 || val.value === 1) {
      var d = this.amaService.sampleDataFromApi['data'].audience[2].options[val.key];
      var z = d == 0 ? 1 : 0
      this.amaService.sampleDataFromApi['data'].audience[2].options[val.key] = z;
      var d1 = this.age_arr.findIndex(va => va === val.key);
      if (d1 === -1) {
        this.age_arr.push(val.key);
      }
      else {
        this.age_arr.splice(d1, 1);
      }
    }
  }

  // initialSubmit(){
    
  //   this.amaService.postQuestion(this.postData).subscribe((result)=>{
  //     console.log('after post result postQuestion Main :: ',result);
  //   },(err)=>{
  //     console.log('after post postQuestion Error :: ',err);
  //   });
  // }

  // previewSubmit() {
  //   console.log("Submit btn clickrf");
  //   this.initialSubmit();
  //   // this.router.navigate(['ama/request-review']);
  // }

  InputQuestionFunction = (Id:any) =>
  {
    this.Question = Id.value;
    console.log(this.Question);
  }
  OptionFunction = (Id:any,i:number) =>
  {
    var obj = {};
    obj[Id.name] = Id.value;
    this.Arr[+i] = obj;
    console.log(this.Arr);
  }


  submitQuestion(){
    console.log('Question Detals Show',this.amaService.newQuestion)
    this.amaService.audience;
    this.amaService.newQuestion.question[0].C = this.amaService.choices.map(item => item.value).filter(c => c);
    this.amaService.newQuestion.question[0].T = Object.keys(this.amaService.qTypes).find(item => { return this.amaService.qTypes[item] == 1 })
    this.amaService.newQuestion.audience.gender = Object.keys(this.amaService.audience[0].options).filter(item => { return this.amaService.audience[0].options[item] == 1 })
    this.amaService.newQuestion.audience.city = Object.keys(this.amaService.audience[1].options).filter(item => { return this.amaService.audience[1].options[item] == 1 })
    this.amaService.newQuestion.audience.age = Object.keys(this.amaService.audience[2].options).filter(item => { return this.amaService.audience[2].options[item] == 1 })
    if (this.amaService.newQuestion.question[0].C.length < 1) {
      this.isNoOptionAdded = true;
      return;
    }else{
      this.isNoOptionAdded = false;
    }
    // console.log("new question ",this.amaService.newQuestion);
    this.amaService.postQuestion(this.amaService.newQuestion).subscribe((result)=>{
          this.amaService.QuestionInputData['Question'] = this.amaService.newQuestion.question[0].Q;
          this.amaService.QuestionInputData['Options'] = this.amaService.newQuestion.question[0].C;
          this.amaService.QuestionInputData['Gender'] = this.amaService.newQuestion.audience['gender'][0]
          this.amaService.QuestionInputData['Select'] = this.amaService.newQuestion.question[0].T;
          this.amaService.QuestionInputData['NCCS'] = this.amaService.newQuestion.audience['SEC'];
          this.amaService.QuestionInputData['City'] = this.amaService.newQuestion.audience['city'];
          this.amaService.QuestionInputData['Age_Group'] = this.amaService.newQuestion.audience['age'];
          // console.log('after post result postQuestion Main :: ',result);
          this.router.navigate(['ama/request-review']);
          this.amaService.currentQuestionId = result['question_id']
        },(err)=>{
          console.log('after post postQuestion Error :: ',err);
        });
  }

  removeChoice(i) {
    // console.log("Removing a input field to option");
    this.amaService.choices.splice(i, 1);
    this.amaService.choices = JSON.parse(JSON.stringify(this.amaService.choices))
  }

  addChoice() {
    // console.log("adding a input field to option");
    this.amaService.choices.push({ value: "" });
    this.amaService.choices = JSON.parse(JSON.stringify(this.amaService.choices))
  }
  

 


}
